import { ModalBase } from "../../../../components/Modals/ModalBase"
import InputForm from "../InputFormV2"

import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import { useEffect } from "react"
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto"
import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import useUtilsDocs, { esCatalogoProductoByTipo } from "../../../../actions/utils-documentos.actions"
import {calculoDeLinea} from '../../../../utils/calculo-otros-documentos'

export default function ModalEditarProductoNCE (props: any) {
    const {unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos);
    const {processOtrosImpuestosCalculo} = useUtilsDocs();

    const {formProducto, onChangeFormProducto, onClickCerrarModalEditarProducto, onChangeSelectCatalogoProducto, onClickActualizarProducto, errors} = props

    const {neto, descuento, subtotal, iva, otrosImpuestos, total} = calculoDeLinea(formProducto, {
        sinIva: props.facturaExportacion,
        otrosImpuestosDeLinea: (venta) => processOtrosImpuestosCalculo(props.dteCode, formProducto, venta),
        otrosImpuestosEnTotal: true,
    })

    useEffect(() => {
        if(formProducto.exento) onChangeFormProducto('conIva', false)
    }, [formProducto.exento])
    
    useEffect(() => {
        if(formProducto.conIva) onChangeFormProducto('exento', false)        
    }, [formProducto.conIva])

    return (
        <ModalBase>
            <div className="cf-modal-container">
                <label className="cf-section-title">{formProducto.servicioDescuento ? "Descuento": formProducto.servicio ? 'Servicio' : 'Producto'}</label>
                <hr className="separador"/>
                {formProducto.servicioDescuento ? <>
                    <div className="cf-row-inputs">
                        <InputForm
                            disabled = {props.notaRemision} 
                            maxLength = {100}
                            type = 'text'
                            value = {formProducto.descripcion}
                            name = 'descripcion'
                            onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                            placeholder = 'Descripción'
                            required
                            label = 'Descripción'
                            error = {errors.descripcion}
                        />
                    </div>
                    <div style={{paddingTop: '20px'}} className="cf-row-inputs">
                        <InputForm 
                            disabled = {props.notaRemision}
                            maxLength = {15}
                            type = 'text'
                            value = {formProducto.precio}
                            name = 'precio'
                            onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                            placeholder = 'Precio'
                            required
                            label = 'Precio'
                            error = {errors.precio}
                        />
                    </div>
                    <div className="cf-calculos-producto" style={{marginTop:"3%"}}>
                        <div className="w-layout-hflex button-actions">
                            <button className="button transparent" onClick={onClickCerrarModalEditarProducto}>Cancelar</button>
                            <button className="button" onClick={onClickActualizarProducto}>Actualizar</button>
                        </div>
                    </div>
                </>: <>
                <div style={{display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '20px'}}>
                    {!props.desactivarSwitch &&
                        <SwitchTipoProductoDTE disabled = {props.notaRemision} producto = {!formProducto.servicio} setProducto = {() => onChangeFormProducto('servicio', false)} setServicio = {() => onChangeFormProducto('servicio', true)}/>
                    }
                </div>
                <div className="cf-row-inputs">
                    {
                        (productosCatalogo.length > 0 && formProducto.clave)
                        ? (
                            <InputForm 
                                disabled = {props.notaRemision}
                                type = 'select' 
                                options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.servicio, prod))}
                                keyNameText = 'descripcion' 
                                keyNameValue = 'clave' 
                                onChange = {(e: any) => onChangeSelectCatalogoProducto(e.value)} 
                                label = 'Descripción' 
                                value = {formProducto.clave}
                            />
                        )
                        : (
                            <InputForm
                                disabled = {props.notaRemision} 
                                maxLength = {100}
                                type = 'text'
                                value = {formProducto.descripcion}
                                name = 'descripcion'
                                onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                placeholder = 'Descripción'
                                required
                                label = 'Descripción'
                                error = {errors.descripcion}
                            />
                        )
                    }
                </div>
                <div style={{paddingTop: '20px'}}>
                    <div className={`ef-form-producto-div4`}>
                    <div className='label-input'>
                    <InputForm 
                        maxLength = {15}
                        type = 'text'
                        value = {formProducto.cantidad}
                        name = 'cantidad'
                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                        placeholder = '0'
                        required
                        label = 'Cantidad'
                        error = {errors.cantidad}
                    />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        type = 'select'
                        value = {formProducto.unidadMedida}
                        name = 'unidad'
                        onChange = {(e: any) => onChangeFormProducto('unidadMedida', e.value)}
                        placeholder = 'Unidad de medida'
                        required
                        label = 'Unidad de medida'
                        options = {unidadesMedida}
                        keyNameText='valor'
                        keyNameValue='codigo'
                        />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        maxLength = {15}
                        type = 'text'
                        value = {formProducto.precio}
                        name = 'precio'
                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                        placeholder = 'Precio'
                        required
                        label = 'Precio'
                        error = {errors.precio}
                    />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        type = 'select'
                        value = {formProducto.tipoDescuento}
                        name = 'tipoDesc'
                        onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}
                        placeholder = 'Tipo de desc.'
                        required
                        label = 'Tipo de desc.'
                        options = {[{value: 'Porcentaje'}, {value: 'Monto'}]}
                        keyNameText='value'
                        keyNameValue='value'
                    />
                    </div>
                    <div className='label-input'>
                    <InputForm 
                        disabled = {props.notaRemision}
                        maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                        leftIcon = {formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                        type = 'text'
                        value = {formProducto.descuento}
                        name = 'descuento'
                        onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                        placeholder = 'Descuento'
                        label = 'Descuento'
                        error = {errors.descuento}
                    />
                    </div>
                    </div>
                </div>
                {!props.facturaExportacion &&
                <div className="cf-calculos-producto">
                    <table>
                        <tbody>
                            <tr className="cf-subtotal">
                                <td>Valor bruto</td>
                                <td>{isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Impuesto al Valor Agregado 13%
                                </td>
                                <td>{isNaN(iva) ? '$0.00' : iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Otros impuestos
                                </td>
                                <td>{isNaN(otrosImpuestos) ? '$0.00' : otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-subtotal">
                                <td>Subtotal</td>
                                <td>{isNaN(subtotal) ? '$0.00' : subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-descuento">
                                <td>Descuento</td>
                                <td>{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-total">
                                <td>Total</td>
                                <td>{isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="w-layout-hflex button-actions">
                        <button className="button transparent" onClick={onClickCerrarModalEditarProducto}>Cancelar</button>
                        <button className="button" onClick={onClickActualizarProducto}>Actualizar</button>
                    </div>
                </div>
                }
                {props.facturaExportacion &&
                    <div className="cf-calculos-producto">
                    <table>
                        <tbody>
                            <tr className="cf-subtotal">
                                <td>Subtotal</td>
                                <td>{isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-descuento">
                                <td>Descuento</td>
                                <td>{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                            <tr className="cf-total">
                                <td>Total</td>
                                <td>{isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="w-layout-hflex button-actions">
                        <button className="button transparent" onClick={onClickCerrarModalEditarProducto}>Cancelar</button>
                        <button className="button" onClick={onClickActualizarProducto}>Actualizar</button>
                    </div>
                </div>
                }
                </>}
            </div>
        </ModalBase>
    )
}